import { PostBig2Tileset } from '../tilesets/PostBig2';
import { PostBigMini2RectTileset } from '../tilesets/PostBigMini2Rect';
import { PostMini2BigMini2Tileset } from '../tilesets/PostMini2BigMini2';
import { PostRectMini2Tileset } from '../tilesets/PostRectMini2';
import { PostRectMini2BigTileset } from '../tilesets/PostRectMini2Big';
import { PostRectVertRectHorizTileset } from '../tilesets/PostRectVertRectHoriz';
import { ensure } from 'components/sharpr/ensure/ensure';
import _ from 'lodash';

/** @ignore */
export default function masonryComponent($compile) {
	'ngInject';
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			posts: '=',
			// stats: '=',
			duration: '<',
			colors: '=',
		},
		controllerAs: 'vm',
		controller: masonryTilesetComponent,
		link: (scope, el) => {
			// this link function runs after the constructor runs
			let tilesets = `<div class="masonry-inner" ng-style="{transform:vm.getCssTransform()}">
				${scope.vm.uncompiledHtml}
			 </div>`;
			let compiled = $compile(tilesets)(scope);
			el.append(compiled);
		},
	};
}

/**
 * Component to manage the masonry newsroom layout
 */
class masonryTilesetComponent {
	/**
	 * @param {Object} $interval
	 * @param {Object} $timeout
	 */
	constructor($scope, $timeout, $interval) {
		'ngInject';
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$interval = $interval;
	}

	$onInit() {
		this.processPosts();
		this.generateTemplate();
		this.position = 0;
		this.time = 0;
		this.addListeners();
		this.queueNext();
		this.durationMs = (this.duration || 120) * 1000;
		this.$scope.$watch('vm.posts', () => this.processPosts());
	}

	addListeners() {
		let win = angular.element(window);
		win.on('mousewheel', evt => {
			if (this.isAnimating) {
				return;
			}
			if (evt.deltaY < -1) {
				this.prev();
			} else if (evt.deltaX > 1) {
				this.next();
			}
		});
		win.on('keydown', evt => {
			if (this.isAnimating) {
				return;
			}
			if ([32, 34, 40].indexOf(evt.which) > -1) {
				// space, page down, down arrow
				this.next();
			} else if ([33, 38].indexOf(evt.which) > -1) {
				// page down or down arrow
				this.prev();
			}
		});
	}

	queueNext() {
		this.$interval(() => this.next(), (this.duration || 120) * 1000);
	}

	prev() {
		this.isAnimating = true;
		this.time--;
		this.position = this.time % Math.floor(this.posts.length / 4);
		// TODO: after CSS transform, move top items to the bottom
		this.$timeout(() => {});
		setTimeout(() => (this.isAnimating = false), 2000);
	}

	next() {
		this.isAnimating = true;
		this.time++;
		this.position = this.time % Math.floor(this.posts.length / 4);
		// TODO: after CSS transform, move top items to the bottom
		this.$timeout(() => {});
		setTimeout(() => (this.isAnimating = false), 2000);
	}

	/**
	 * Get the translateY(-##vh) string based on the current scroll position
	 * @returns {string}
	 */
	getCssTransform() {
		return `translateY(-${this.position * 80}vh)`;
	}

	getImageUrl(post, dimensions) {
		if (post.masonry && post.masonry.imageUrl) {
			return `url('${post.masonry.imageUrl}.exact-${dimensions.width}x${dimensions.height}.jpg')`;
		} else if (post.logos && post.logos.missing) {
			return `url('${post.logos.missing}')`;
		}
		return '';
	}

	generateTemplate() {
		let classes = _.shuffle([
			PostBig2Tileset,
			PostBigMini2RectTileset,
			PostMini2BigMini2Tileset,
			PostRectMini2Tileset,
			PostRectMini2BigTileset,
			PostRectVertRectHorizTileset,
		]);
		let blocks = [];
		ensure.array(this.posts).forEach((post, i) => {
			let tileset = new classes[i % classes.length]();
			let color = this.colors[i % this.colors.length];
			tileset.load(post);
			let html = tileset
				.getUncompiledHtml()
				.replace(/\bbgColor\b/g, `'${color}'`)
				.replace(/\bpost\b/g, `vm.posts[${i}]`);
			blocks.push(`
				<div class="masonry-tileset" data-type="${tileset.name}" ng-style="{backgroundColor:'${color}'}">
					${html}
				</div>
			`);
		});
		this.uncompiledHtml = blocks.join('\n');
	}

	processPosts() {
		ensure.array(this.posts).forEach((post, i) => {
			let hasInsight = !!post.intel_text;
			let hasHeadline = !!post.headline;
			let hasCategory = post.category && post.category.name && post.category.name != 'Uncategorized';
			let hasSource = post.domain_name || post.source_name;
			let hasAuthor = !!post.source_author;
			let hasPublisher = post.published_by && post.published_by.id;
			let hasTags = post.tags && post.tags.length > 0;
			let tagNames = hasTags
				? post.tags
						.map(t => _.trim(t.name, ','))
						.slice(0, 3)
						.join(', ')
				: null;
			let hasPubDate = !!post.published_at;
			let hasLikes = post.likes_count > 1;
			let hasComments = post.comment_count > 1;
			let hasImage;
			let imageUrl;
			if (post.image && post.image.url) {
				hasImage = true;
				imageUrl = post.image.url;
			} else if (post.attachment_thumbnails && post.attachment_thumbnails.length && post.attachment_thumbnails[0].url) {
				hasImage = true;
				imageUrl = post.attachment_thumbnails[0].url;
			} else {
				hasImage = false;
				imageUrl = '';
			}
			post.masonry = {
				hasImage,
				hasInsight,
				hasHeadline,
				hasCategory,
				hasSource,
				hasAuthor,
				hasPublisher,
				hasTags,
				tagNames,
				hasPubDate,
				hasLikes,
				hasComments,
				imageUrl,
				renderer: null,
				classes: {
					content: [],
					metadata: [],
				},
				score: {
					content: Number(hasImage) + Number(hasInsight) + Number(hasHeadline),
					metadata:
						Number(hasCategory) +
						Number(hasSource) +
						Number(hasAuthor) +
						Number(hasPublisher) +
						Number(hasTags) +
						Number(hasPubDate) +
						Number(hasLikes) +
						Number(hasComments),
				},
			};
		});
	}
}
